export default __webpack_public_path__ + "static/media/fc_icon_terrible_active.02c0a3c2.svg";